import {
  BaseService,
  Body,
  DELETE,
  GET,
  Headers,
  PATCH,
  Path,
  POST,
  PUT,
  Query,
  Response,
  ResponseType
} from 'ts-retrofit';
import {ACCEPT_JSON} from '../config';
import {ToData, ToListedResponse} from '../rest-api-hydratator-decorators';
import {ListedResponse} from '../../../models/hydratator/listed-response';
import {MediaSource} from '../../../models/media-source';
import {UploadMediaRequest} from '../../../models/requests/upload-media-request';
import {BodyRequest} from '../../../models/body-request';
import {FilterMediaSourceRequest} from '../../../models/requests/filter-media-source.request';

const base = 'media-source';

export class MediaSourceApiService extends BaseService {

  @POST(`/${base}/filter`)
  @Headers({...ACCEPT_JSON})
  @ToListedResponse(MediaSource)
  async filter(@Body request: FilterMediaSourceRequest): Promise<Response<ListedResponse<MediaSource>>> {
    return <Response>{};
  }

  @DELETE(`/${base}/{id}`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async deleteById(@Path('id') id: number): Promise<Response<MediaSource>> {
    return <Response>{};
  }

  @PATCH(`/${base}/{id}/restore`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async restoreById(@Path('id') id: number): Promise<Response<MediaSource>> {
    return <Response>{};
  }

  @GET(`/${base}/{id}`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async getById(@Path('id') id: number): Promise<Response<MediaSource>> {
    return <Response>{};
  }

  @GET(`/${base}/{id}/download`)
  @ResponseType('blob')
  async download(@Path('id') id: number): Promise<Response<Blob>> {
    return <Response>{};
  }

  @POST(`/${base}`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async upload(@Body uploadMediaSourceRequest: UploadMediaRequest): Promise<Response<MediaSource>> {
    return <Response>{};
  }

  @PUT(`/${base}`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async update(@Body mediaSource: MediaSource): Promise<Response<MediaSource>> {
    return <Response>{};
  }

  @PATCH(`/${base}/{id}/name`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(MediaSource)
  async updateName(@Path('id') id: number, @Body name: BodyRequest<string>): Promise<Response<MediaSource>> {
    return <Response>{};
  }



}
